<template>
  <div class="col-lg-6">
    <div class="input-group m-b typeahead">
      <autocomplete
        v-shortkey="['ctrl', 'k']"
        @shortkey.native="focusOnInput()"
        ref="autocompleteInput"
        :search="fetch"
        :get-result-value="getResult"
        @submit="goToSite"
        :debounceTime="100"
        :defaultValue="def"
        placeholder="Ctrl + k"
      >
        <template #result="{ result, props }">
          <li v-bind="props" class="">
            <a>{{ result.domain }}</a>
            {{ result.client ? result.client.name : '/' }}
          </li>
        </template>
      </autocomplete>
    </div>
  </div>
</template>
<script>

import axios from 'axios'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

export default {
  name: 'Typeahead',
  components: {
    autocomplete: Autocomplete
  },
  props: {
    placeholder: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      results: [],
      items: '',
      query: '',
      def: ''
    }
  },
  mounted () {
  },
  methods: {
    fetch (query) {
      return new Promise(resolve => {
        if (query.length >= this.min) {
          axios.get('/pbn/search?term=' + query)
            .then(r => {
              resolve(r.data.data)
            })
            .catch(e => {
              resolve([])
            })
        } else {
          resolve([])
        }
      })
    },
    reset () {
      this.results = []
      this.query = ''
    },
    getResult (val) {
      return val.domain
    },
    goToSite (v) {
      this.$router.push('/pbn/' + v.punyDomain)
      this.def = ''
    },
    focusOnInput () {
      this.$refs.autocompleteInput.$el.getElementsByClassName('autocomplete-input').item(0).focus()
    }
  }
}
</script>
<style scoped>
.addQuickView {
  position: absolute;
  top: 20px;
  right: 10px;
  cursor: copy;
}
.typeahead {
  margin-top: 14px;
}
.results {
    display: block;
    top: 35px;
    left: 17px;
    text-align: left;
    position: absolute;
    border: medium none;
    border-radius: 3px;
    /*padding: 0px 5px;*/
    box-shadow: 0 0 3px rgba(86, 96, 117, 0.7);
    z-index: 100;
}
.results li {
    position: relative;
    margin: 0;
    list-style: none;
    width: 100%;
/*    transition: ease-in-out 0.3s;*/
    padding: 10px;
    width: 300px;
}
.dropdown-item {
  padding: 0px;
}
.user {
  display: flex;
  flex-wrap: wrap;
}
.flags {
  margin-right: 15px;
}
.flag {
  margin-top: 2px;
}
.userdata p {
  margin: 0px;
}
a {
  height: 40px;
}
.results li:hover, a:hover {
    border-radius: 3px;
    color: #fff !important;
    text-decoration: none;
    background-color: #1ab394 !important;
    outline: 0;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Addons/TypeAhead.vue